/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedResponseOfAuditEntryItem } from '../../models/paged-response-of-audit-entry-item';

export interface AuditSubject$Json$Params {
  subjectType: string;
  subjectId: string;
  Page?: (number | string);
  PageSize?: (number | string);
  Sort?: string;
  Q?: string;
  Filter?: {
[key: string]: string;
};
}

export function auditSubject$Json(http: HttpClient, rootUrl: string, params: AuditSubject$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedResponseOfAuditEntryItem>> {
  const rb = new RequestBuilder(rootUrl, auditSubject$Json.PATH, 'get');
  if (params) {
    rb.path('subjectType', params.subjectType, {});
    rb.path('subjectId', params.subjectId, {});
    rb.query('Page', params.Page, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Sort', params.Sort, {});
    rb.query('Q', params.Q, {});
    rb.query('Filter', params.Filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedResponseOfAuditEntryItem>;
    })
  );
}

auditSubject$Json.PATH = '/api/v1/platform/audit/subjects/{subjectType}/{subjectId}';
